(() => {
  const root = document.querySelector('[data-dream-hero]');
  if (!root) return;

  const details = Array.from(root.querySelectorAll('.dream-hero__details'));
  if (!details.length) return;

  details.forEach((d) => {
    d.addEventListener('toggle', () => {
      if (!d.open) return;
      details.forEach((other) => {
        if (other !== d) other.removeAttribute('open');
      });
    });
  });
})();
